import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { IApplicationService } from 'Shared/eservices-base/interfaces/IApplication-Service';
import { Observable } from 'rxjs';
import { ResultDetails } from 'Shared/models/result-details';

@Injectable({
  providedIn: 'root'
})
export class InquiryService implements IApplicationService {


  private loadUrl: string;
  private saveUrl: string;
  private validationUrl: string;
  private resendMail: string;
  constructor(private http: HttpClient) {
    this.loadUrl = environment.inquiry__loadApplication;
    this.saveUrl = environment.inquiry_saveApplication;
    this.validationUrl = environment.inquiry_checkRequestValidation;
    this.resendMail = environment.inquiry_resendMail;
  }
  loadApplication(applicationId: string, taskId: string): Observable<ResultDetails> {
    let url = `${this.loadUrl}?applicationId=${applicationId}&taskId=${taskId}`;
    return this.http.get<ResultDetails>(url);
  }
  saveApplication(application: any): Observable<ResultDetails> {
    let apiHeader = new HttpHeaders();
    let contentType = apiHeader.append('Content-Type', 'application/json');
    let aControl = contentType.append("Access-Control-Allow-Methods", "DELETE, POST, GET, OPTIONS");
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    };
    let applicationJson = JSON.stringify(application);
    return this.http.post<ResultDetails>(this.saveUrl, applicationJson, httpOptions);
  }
  CheckUserIsVaildToViewApplication(secuirtyCode: string, referenceNumber: string): Observable<ResultDetails> {
    let url = `${this.validationUrl}?secuirtyCode=${secuirtyCode}&referenceNumber=${referenceNumber}`;
    return this.http.get<ResultDetails>(url);
  }
  ResendSecuirtyCode(applicationId: string): Observable<ResultDetails> {
    let url = `${this.resendMail}?applicationId=${applicationId}`;
    return this.http.get<ResultDetails>(url);
  }
}
